/**
 * Function that sorts arrays or Float64Arrays in descending order
 * @param array - array to sort
 * @returns sorted array
 */
export function xSortDescending(array) {
    if (ArrayBuffer.isView(array)) {
        array.sort().reverse();
        return array;
    }
    else if (Array.isArray(array)) {
        array.sort((a, b) => b - a);
        return array;
    }
    throw new Error('trying to sort non array');
}
//# sourceMappingURL=xSortDescending.js.map